module.exports = __webpack_public_path__ + "img/5-2.68071eaa.png";